/**
 * Usual attributes for when presenting BodySideType
 */
export enum BodySideAttribute {
    TITLE,
    COLOR,
    ICON,
}
